import { TypedAction } from '@ngrx/store/src/models';
import { setPriceFilterBasedOnUrlValues } from './price.actions';
import { AppState, UrlPartSerializer } from '@immosky/types';

export class PriceFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const values = urlValue.split(',').map((v) => v.trim());

    const min = parseInt(values[0], 10);
    const max = parseInt(values[1], 10);

    return setPriceFilterBasedOnUrlValues({
      values: {
        min,
        max,
      },
    });
  }

  serialize(state: AppState): string {
    const priceFilter = state.filter.price.filter;
    return `${priceFilter.min.value},${priceFilter.max.value}`;
  }
}
